import React from 'react';
import PropTypes from 'prop-types';

import {
  WrapperStyled,
  LogoStyled,
  PanelStyled,
  CardStyled,
  TitleWrapperStyled,
  TitleStyled,
  StepsStyled,
  MessageStyled,
  ExternalLink,
  LogoContainer
} from './auth.styles';

import AuthPatternImage from 'assets/patterns/auth-pattern';
import { SignInCard } from 'shared/components';

const AuthLayout = ({
  id,
  title,
  titleCentered,
  steps,
  icon: Icon,
  showPattern,
  showAlerts,
  children
}) => {
  const windowHeight = window.outerHeight;
  const nonUrgentCard = JSON.parse(
    process.env.REACT_APP_LOG_IN_MESSAGE || '{}'
  );
  return (
    <WrapperStyled data-testid="auth">
      <LogoContainer>
        <LogoStyled />
      </LogoContainer>
      <PanelStyled screenHeight={windowHeight <= 800 ? 'md' : 'lg'}>
        {showAlerts &&
          process.env.REACT_APP_LOG_IN_MESSAGE_ENABLED === 'true' && (
            <SignInCard
              className="non-urgent"
              iconLink={nonUrgentCard?.icon}
              title={nonUrgentCard?.title}
            >
              {nonUrgentCard?.link ? (
                <ExternalLink href={nonUrgentCard?.link} target="_blank">
                  {nonUrgentCard?.message}
                </ExternalLink>
              ) : (
                <MessageStyled>{nonUrgentCard?.message}</MessageStyled>
              )}
            </SignInCard>
          )}
        <CardStyled data-pendoid={id}>
          {steps ? <StepsStyled aria-label={steps}>{steps}</StepsStyled> : null}
          <TitleWrapperStyled titleCentered={titleCentered}>
            {Icon && <Icon titleCentered={titleCentered} />}
            <TitleStyled aria-label={title}>{title}</TitleStyled>
          </TitleWrapperStyled>
          {children}
        </CardStyled>
      </PanelStyled>
      {showPattern && <AuthPatternImage />}
    </WrapperStyled>
  );
};

AuthLayout.propTypes = {
  title: PropTypes.string.isRequired,
  steps: PropTypes.string,
  titleCentered: PropTypes.bool,
  showPattern: PropTypes.bool,
  showAlerts: PropTypes.bool
};

AuthLayout.defaultProps = {
  steps: '',
  titleCentered: false,
  showPattern: false,
  showAlerts: false
};

export default AuthLayout;
